import { render, staticRenderFns } from "./NofooterHome.vue?vue&type=template&id=e46bd542&scoped=true&"
import script from "./NofooterHome.vue?vue&type=script&lang=js&"
export * from "./NofooterHome.vue?vue&type=script&lang=js&"
import style0 from "./NofooterHome.vue?vue&type=style&index=0&id=e46bd542&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46bd542",
  null
  
)

export default component.exports